import React, { useState } from 'react';
import { db } from "../firebase.js";

import { collection, addDoc, serverTimestamp} from "firebase/firestore";

const Humse3 = () => {
  const [formData, setFormData] = useState({
    // Initial state for your form data
    touristName: '',
    gender: '',
    caste: '',
    category: '',
    mobileNumber: '',
    dateOfBirth: '',
    village: '',
    tehsil: '',
    district: '',
    state: '',
    zipCode: '',
    education: '',
    locationPreference: '',
    roomType: '', // Example for nested preferences
    washroomType: '',
    bedType: '',
    foodPreference: '',
  });

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'radio' ? value : event.target.value, // Handle radio input types
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await addDoc(collection(db, 'touristData'), {
        ...formData,
        timestamp: serverTimestamp(),
      });
      alert('व्यक्ति सफलतापूर्वक जोड़ा गया!');
      setFormData({
        touristName: '',
        gender: '',
        caste: '',
        category: '',
        mobileNumber: '',
        dateOfBirth: '',
        village: '',
        tehsil: '',
        district: '',
        state: '',
        zipCode: '',
        education: '',
        locationPreference: '',
        roomType: '', 
        washroomType: '',
        bedType: '',
        foodPreference: ''
      });
    } catch (error) {
      console.error('Error saving data:', error);
      // Handle errors appropriately (e.g., display an error message)
    }
  };

  return (
    <div className="min-h-screen bg-pink-50 p-4">
      {/* Heading Section */}
      <div className="text-center py-4 md:py-6">
        <h1 className="text-3xl md:text-5xl lg:text-7xl font-extrabold text-[#991311] mb-2">सामाजिक समरस पर्यटन को बढ़ावा देने हेतु जुड़ें</h1>
        <h2 className="text-xl md:text-2xl lg:text-4xl text-gray-700 font-bold">इसके अन्तर्गत मित्रता पूर्ण एक दुसरे के यहाँ आने जाने वालों का विवरण भरना</h2>
      </div>
      
      <div className="flex flex-col lg:flex-row lg:justify-end px-2 md:px-4 lg:px-8 gap-4">
        {/* Left side text container */}
        <div className="w-full lg:w-1/4 lg:pr-8 pt-4 text-[#991311] text-2xl md:text-3xl lg:text-4xl font-bold mt-2 lg:mt-5">
          <p>पर्यटक के रूप में जाने वालों का विवरण </p>
        </div>
        
        {/* Form container */}
        <div className="w-full lg:w-2/3 bg-white p-4 md:p-6 border-2" onSubmit={handleSubmit}>
          <form className="max-w-3xl mx-auto">
            {/* Personal Info Section */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-y-4 md:gap-x-3 md:gap-y-1">
              {/* Name and Gender */}
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">नाम</label>
              </div>
              <div className="col-span-1 md:col-span-4">
                <input 
                  type="text" 
                  placeholder="राम ठाकुर"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="touristName"
                  value={formData.touristName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">लिंग</label>
              </div>
              <div className="col-span-1 md:col-span-4 flex flex-wrap gap-3">
                <div className="flex items-center gap-1">
                  <input 
                    type="radio" 
                    name="gender" 
                    id="male" 
                    value="Male"
                    checked={formData.gender === 'Male'}
                    onChange={handleChange} 
                  />
                  <label className="text-xs" htmlFor="male">Male</label>
                </div>
                <div className="flex items-center gap-1">
                  <input 
                    type="radio" 
                    name="gender" 
                    id="female" 
                    value="Female"
                    checked={formData.gender === 'Female'}
                    onChange={handleChange} 
                  />
                  <label className="text-xs" htmlFor="female">Female</label>
                </div>
              </div>

              {/* Caste and Category */}
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">जाति</label>
              </div>
              <div className="col-span-1 md:col-span-4">
                <input 
                  type="text" 
                  placeholder="राजस"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="caste"
                  value={formData.caste}
                  onChange={handleChange}
                  required
                />
              </div>
              
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">वर्ग</label>
              </div>
              <div className="col-span-1 md:col-span-4 flex flex-wrap gap-3">
                {['ST', 'SC', 'OBC', 'Gen'].map((category) => (
                  <div key={category} className="flex items-center gap-1">
                    <input
                      type="radio"
                      name="category"
                      id={category.toLowerCase()}
                      value={category} // Set the value to be the category
                      checked={formData.category === category} // Check if the current category is selected
                      onChange={handleChange} // Handle change event
                    />
                    <label className="text-xs" htmlFor={category.toLowerCase()}>
                      {category}
                    </label>
                  </div>
                ))}
              </div>

              {/* Contact Information */}
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">मोबाइल नंबर</label>
              </div>
              <div className="col-span-1 md:col-span-4">
                <input 
                  type="text" 
                  placeholder="+91 555 555-1234"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">जन्म तिथि</label>
              </div>
              <div className="col-span-1 md:col-span-4">
                <input 
                  type="date" 
                  placeholder="12.05.1992"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Address Fields */}
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">गाँव</label>
              </div>
              <div className="col-span-1 md:col-span-2">
                <input 
                  type="text" 
                  placeholder="राजस"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="village"
                  value={formData.village}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">तहसील</label>
              </div>
              <div className="col-span-1 md:col-span-2">
                <input 
                  type="text" 
                  placeholder="उदयपुर"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="tehsil"
                  value={formData.tehsil}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">जिला</label>
              </div>
              <div className="col-span-1 md:col-span-2">
                <input 
                  type="text" 
                  placeholder="उदयपुर"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">राज्य</label>
              </div>
              <div className="col-span-1 md:col-span-2">
                <input 
                  type="text" 
                  placeholder="राजस्थान"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-span-1 md:col-span-2">
                <label className="text-xs">पिन कोड</label>
              </div>
              <div className="col-span-1 md:col-span-2">
                <input 
                  type="text" 
                  placeholder="123456"
                  className="w-full border-b border-gray-300 text-gray-500 text-sm"
                  name="zipCode"
                  value={formData.zipCode}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            {/* Education Section */}
            <div className="py-2">
              <label className="text-sm">शिक्षा</label>
              <select
                name="education"
                value={formData.education}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
                required
              >
                <option value="1">ग्राम पाठशाला</option>
                <option value="2">माध्यमिक शिक्षा</option>
                <option value="3">उच्च शिक्षा</option>
                <option value="4">डिप्लोमा</option>
              </select>
            </div>

            {/* Preferences Section */}
            <h1 className='text-2xl font-bold text-[#afa351] mt-7 mb-7'>किस प्रकार के स्थान पर पर्यटन हेतु जाना पसंद करेंगे </h1>
            <div className="py-2">
              <label className="text-sm">किस प्रकार के स्थान पर पर्यटन हेतु जाना पसंद करेंगे </label>
              <select
                name="locationPreference"
                value={formData.locationPreference}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
              >
                <option value="गाँव">गाँव</option>
                <option value="शहर">शहर</option>
                <option value="अर्ध शहर">अर्ध शहर</option>
                <option value="पहाड़">पहाड़</option>
                <option value="प्राकृतिक वातावरण">प्राकृतिक वातावरण</option>
              </select>
            </div>

            <div className="py-2">
              <label className="text-sm">कक्ष प्रकार</label>
              <select
                name="roomType"
                value={formData.roomType}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
              >
                <option value="single">सिंगल</option>
                <option value="double">डबल</option>
              </select>
            </div>

            <div className="py-2">
              <label className="text-sm">स्वच्छता</label>
              <select
                name="washroomType"
                value={formData.washroomType}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
              >
                <option value="attached">जुड़ा हुआ</option>
                <option value="common">सामान्य</option>
              </select>
            </div>

            <div className="py-2">
              <label className="text-sm">बेड प्रकार</label>
              <select
                name="bedType"
                value={formData.bedType}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
              >
                <option value="single">सिंगल</option>
                <option value="double">डबल</option>
              </select>
            </div>

            <div className="py-2">
              <label className="text-sm">भोजन प्राथमिकता</label>
              <select
                name="foodPreference"
                value={formData.foodPreference}
                onChange={handleChange}
                className="w-full text-gray-500 border-b border-gray-300 p-1"
              >
                <option value="veg">शाकाहारी</option>
                <option value="non-veg">मांसाहारी</option>
              </select>
            </div>

            {/* Submit Button */}
            <div className="pt-4">
              <button
                type="submit"
                className="w-full py-2 text-lg font-semibold text-white bg-[#991311] rounded-md"
              >
                जमा करें
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Humse3;
